import { PARTNER360_NAMESPACE } from '../common/constants'

export const PARTNER360_COMMITMENT_NAMESPACE = `${PARTNER360_NAMESPACE}/commitment`
// Async thunk constants
export const REQUEST_COMMITMENT_ITEMS = `${PARTNER360_COMMITMENT_NAMESPACE}/requestCommitmentItems`
export const REQUEST_COMMITMENT_STATUSES = `${PARTNER360_COMMITMENT_NAMESPACE}/requestCommitmentStatuses`
export const REQUEST_ACKNOWLEDGEMENT = `${PARTNER360_COMMITMENT_NAMESPACE}/requestAcknowledgement`
export const ACTION_PLAN_REVIEW = `${PARTNER360_COMMITMENT_NAMESPACE}/actionPlanReview`
